import React, { useState, useEffect, useContext } from "react";
import StockistReportHeader from "../../stockist_report/StockistReportHeader";
import Sidebar from "../../supervisor_home/sidebar/Sidebar";
import OtherSidebar from "../../operator_home/sidebar/Sidebar";
import { ReactSession } from "react-client-session";
import { Pagination } from "../../claim/claim_table/Pagination";
import { errorToast } from "../../../toast";
import FormContext from "../../../context/FormContext";
import useAPI from "../../../hooks/useAPI";
import InvoiceTool from "../invoice_update/InvoiceTool";
import InvoiceTable from "./InvoiceTable";
// import InvoiceFilter from "./InvoiceFilter"; // Uncomment if using

const InvoicePage = () => {
  const role = ReactSession.get("role");
  const { setIsLoading } = useContext(FormContext);
  const { getAPI } = useAPI();

  const [user, setUser] = useState({ user_info: null, current_plant: "" });
  const [invoiceRecord, setInvoiceRecord] = useState([]);
  const [pagination, setPagination] = useState({
    next: null,
    previous: null,
    count: 0,
  });

  // Fetch User Info
  const fetchUserInfo = async () => {
    try {
      setIsLoading(true);
      const response = await getAPI("/auth/users?current_user_only=true");
      setUser({
        user_info: response || {},
        current_plant: response?.plant_code_list?.[0] || "",
      });
    } catch (error) {
      console.error("Fetch User Info Error:", error);
      errorToast(
        `Failed to fetch User info: ${error?.response?.status || "Unknown"}`,
        2000
      );
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchUserInfo();
  }, []);

  return (
    <div className="claim__page">
      <StockistReportHeader />
      {role === "2" ? <Sidebar /> : <OtherSidebar />}

      <div
        className="claim__container"
        style={{ display: "flex", flexDirection: "column", gap: "4px" }}
      >
        <p className="claim__lab">Invoice Page</p>

        {/* Ensure InvoiceTool renders only when user is fetched */}
        {user?.user_info && (
          <InvoiceTool
            user={user}
            setInvoiceRecord={setInvoiceRecord}
            setPagination={setPagination}
          />
        )}

        {/* Uncomment if you want to use a filter panel */}
        {/* {user?.user_info && (
          <InvoiceFilter
            user_info={user}
            setUser={setUser}
            setInvoiceRecord={setInvoiceRecord}
            setPagination={setPagination}
          />
        )} */}

        {invoiceRecord.length > 0 && (
          <>
            <Pagination
              pagination={pagination}
              setPagination={setPagination}
              setClaimRecord={setInvoiceRecord}
            />

            <InvoiceTable invoiceRecord={invoiceRecord} />
          </>
        )}
      </div>
    </div>
  );
};

export default InvoicePage;
